import { apiClient } from '../../app/api';
import type { CategoryView } from './types';

export function listCategories(): Promise<CategoryView[]> {
  return apiClient.get<CategoryView[]>('/admin/categories');
}

export function listAllCategories(): Promise<CategoryView[]> {
  return apiClient.get<CategoryView[]>('/admin/categories/all');
}
